import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Typography, Avatar } from "@mui/material";
import PhoneIcon from "../../assets/otp_logo.png";
import backgroundImg from "../../assets/login_bg.png";
import gift_logo from "../../assets/gift_logo.png";
import { useLocation } from "react-router-dom";
import {
  

  Divider,
} from "@mui/material";
export default function OtpVerification({
  handleSubmitOtp,
  setFinalOtp,
  resendCode,
  setIsOTPScreen
}) {
  const [otp, setOtp] = useState([]);
  const [timeLeft, setTimeLeft] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const hiddenInputRef = useRef(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get("route");

  let tagOrderId = null;
  if (url && url.includes("value=")) {
    tagOrderId = url.split("value=")[1];
  }
  const backtomobile = () => {
    setIsOTPScreen(false);
  }

  // ⏱ Countdown timer
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft((t) => t - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  // 🔐 Auto-submit when OTP complete
  useEffect(() => {
    if (otp.join("").length === 4) {
      const code = otp.join("");
      setFinalOtp?.(code);
      handleSubmitOtp(code);
    }
  }, [otp]);

  // 🔁 Resend OTP
  const handleResend = () => {
    setOtp([]);
    setTimeLeft(30);
    setCanResend(false);
    resendCode();
  };

  // 🔹 Handle OTP input (auto-fill / paste / typing)
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setOtp(value.split(""));
  };

  return (
    <Box

      onClick={() => hiddenInputRef.current?.focus()}
    >
      <Box
        sx={{
          maxWidth: 400,
          width: "100%",
          borderRadius: 2,
          p: 4,
          pt: 2,
          textAlign: "center",
          bgcolor: { xs: "transparent", sm: "white" },
          boxShadow: { xs: "none", sm: 3 }
        }}
      >
  

     
      <Divider sx={{ my: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            OTP
          </Typography>
        </Divider>
        {/* 🔐 Hidden input (ONLY real input for autofill) */}
        <input
          ref={hiddenInputRef}
          type="tel"
          inputMode="numeric"
          autoComplete="one-time-code"
          onChange={handleOtpChange}
          value={otp.join("")}
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none"
          }}
        />

        {/* 📦 OTP Boxes (UI only) */}
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mb: 3 }}>
          {[0, 1, 2, 3].map((i) => (
            <Box
              key={i}
              sx={{
                width: 50,
                height: 50,
                border: "1px solid black",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                backgroundColor: "#f5f5f5"
              }}
            >
              {otp[i] || ""}
            </Box>
          ))}
        </Box>

        {/* 🔁 Resend */}
        <Typography variant="body2">
          Didn’t receive code?{" "}
          {canResend ? (
            <Button onClick={handleResend} sx={{ p: 0, color: "#00B177" }}>
              Resend
            </Button>
          ) : (
            `Resend in ${timeLeft}s`
          )}
        </Typography>

        {/* 🔙 Change number */}
        <Typography
          mt={3}
          mb={2}
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "#00B177"

          }}
          onClick={(e) => backtomobile()}
        >
          Tap here to change phone number
        </Typography>

        {/* ✅ Verify */}
        <Button
          fullWidth
          variant="contained"
           
          disabled={otp.join("").length !== 4}
          sx={{
            bgcolor: otp.join("").length !== 4 ? "#cfcfcf":"#12b981" ,
            p: 2,
            fontWeight: "bold"
            ,
            "&:hover": {
              bgcolor:otp.join("").length !== 4  ? "#0ea371" : "#0ea371",
            },
            
          }}
          onClick={() => handleSubmitOtp(otp.join(""))}
        >
          VERIFY
        </Button>
      </Box>
    </Box>
  );
}
